/**
 * Holding Companies Service
 * HTTP operations for holding companies catalog
 */

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetHoldingCompaniesOut, HoldingCompany } from './holding.types';
import { mapHoldingCompanies } from './holding.mapper';

/**
 * Service class for holding companies catalog operations
 */
export class HoldingService {
  /**
   * Get holding companies for authenticated user
   * GET /v{version}/catalog/company/holding-companies
   * Returns all companies within the same holding as the authenticated user
   */
  async list(): Promise<ApiResponse<HoldingCompany[]>> {
    const response = await apiClient.get<LC_GetHoldingCompaniesOut>(
      API_CONFIG.ENDPOINTS.HOLDING.COMPANIES,
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    try {
      const companies = mapHoldingCompanies(response.data);
      return { ...response, data: companies };
    } catch {
      return { ...response, data: null, success: false };
    }
  }
}

export const holdingService = new HoldingService();
